export const headers = [
  {
    text: 'Placa',
    align: 'start',
    sortable: true,
    value: 'plate',
    width: '15%'
  },
  {
    text: 'Data criação',
    align: 'start',
    sortable: true,
    value: 'createdDate', 
    width: '10%'
  },
  {
    text: 'Cliente',
    align: 'start',
    sortable: true,
    value: 'client',
    width: '15%'
  },
  {
    text: 'Modelo',
    align: 'start',
    sortable: true,
    value: 'model',
    width: '10%'
  },
  {
    text: 'Ano',
    align: 'start',
    sortable: true,
    value: 'year',
    width: '15%'
  },
  {
    text: 'Isolado',
    align: 'start', 
    sortable: true,
    value: 'isolated',
    width: '5%'
  },
  {
    text: 'Ativo',
    align: 'start',
    sortable: true,
    value: 'active',
    width: '5%'
  },
  {
    text: 'Ações',
    value: 'actions',
    align: 'right',
    sortable: false,
    width: '10%'
  }
]

